export interface WorkingDaysType {
    id: string | number;
    request_date: string | Date;
    deadline_date: string | Date;
    assign: string;
}

export const initWorkingDaysType = (): Omit<WorkingDaysType, 'assign'> => {
    return {
        id: '',
        request_date: new Date(),
        deadline_date: new Date(),
    };
};
